import { connect, mapReadPretty } from '@eastcoal/formily/exports/react'

import { BankAccountSelect as LocalBankAccountSelect } from '../../components/BankAccountSelect'

export const BankAccountSelect = connect(
  LocalBankAccountSelect,
  mapReadPretty(LocalBankAccountSelect, {
    disabled: true
  })
)
